export default __webpack_public_path__ + "static/media/barco-atardecer-pies-del-lago.897b0e0a.jpeg";